// @index('./*.ts', f => `export * from '${f.path}';`)
export * from './ion-component-preloader.component';
export * from './ion-component-preloader.module';
// @endindex